import React from "react";

const circleShape = ({
  color = "#ABDBFF",
  width = 80,
  height = 80,
  label,
  labelStyle,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
    >
      <circle cx="40" cy="40" r="40" fill={color} />
      <foreignObject x="10" y="20" width="60" height="40">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "break-word",
              color: labelStyle?.color || "#fff",
              fontSize: labelStyle?.fontSize || "10px",
              fontFamily: labelStyle?.fontFamily || "inherit",
              lineHeight: "1.2em",
            }}
          >
            {label}
          </div>
        </div>
      </foreignObject>
    </svg>
  );
};

const softShape = ({
  color = "#ABDBFF",
  width = 80,
  height = 80,
  label,
  labelStyle,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 75 78"
      fill="none"
    >
      <path
        d="M32.0099 2.3924C35.4922 0.304142 39.8418 0.304143 43.3241 2.3924L46.3751 4.22199C47.8027 5.07803 49.4059 5.59894 51.064 5.74547L54.6077 6.05864C58.6524 6.41609 62.1713 8.9727 63.7611 12.709L65.154 15.9825C65.8058 17.5142 66.7966 18.8779 68.0519 19.9711L70.7347 22.3074C73.7969 24.974 75.141 29.1107 74.231 33.0679L73.4338 36.5349C73.0608 38.1572 73.0608 39.8428 73.4338 41.4651L74.231 44.9321C75.141 48.8893 73.7969 53.026 70.7347 55.6926L68.0519 58.0289C66.7966 59.1221 65.8058 60.4858 65.154 62.0175L63.7611 65.291C62.1713 69.0273 58.6524 71.5839 54.6077 71.9414L51.064 72.2545C49.4059 72.4011 47.8027 72.922 46.3751 73.778L43.3241 75.6076C39.8418 77.6959 35.4922 77.6959 32.0099 75.6076L28.9588 73.778C27.5313 72.922 25.9281 72.4011 24.27 72.2545L20.7263 71.9414C16.6816 71.5839 13.1627 69.0273 11.5729 65.291L10.1799 62.0175C9.52821 60.4858 8.53738 59.1221 7.2821 58.0289L4.59924 55.6926C1.53709 53.026 0.193002 48.8893 1.10294 44.9321L1.90017 41.465C2.27318 39.8428 2.27318 38.1572 1.90017 36.535L1.10294 33.0679C0.193002 29.1107 1.53709 24.974 4.59925 22.3074L7.28211 19.9711C8.53739 18.8779 9.52822 17.5142 10.1799 15.9825L11.5729 12.709C13.1627 8.9727 16.6816 6.41609 20.7263 6.05864L24.27 5.74547C25.9281 5.59894 27.5313 5.07803 28.9588 4.22199L32.0099 2.3924Z"
        fill={color}
      />
      <foreignObject x="5" y="20" width="70" height="40">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "break-word",
              color: labelStyle?.color || "#fff",
              fontSize: labelStyle?.fontSize || "10px",
              fontFamily: labelStyle?.fontFamily || "inherit",
              lineHeight: "1.2em",
            }}
          >
            {label}
          </div>
        </div>
      </foreignObject>
    </svg>
  );
};

const wavyShape = ({
  color = "#ABDBFF",
  width = 80,
  height = 80,
  label,
  labelStyle,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 73 76"
      fill="none"
    >
      <path
        d="M33.2811 1.60217C34.8788 -0.283563 37.7872 -0.28356 39.3849 1.60217L44.1285 7.20098C45.1082 8.35733 46.6573 8.86067 48.1296 8.50101L55.2581 6.75967C57.659 6.17317 60.012 7.88273 60.1962 10.3474L60.7429 17.6651C60.8558 19.1765 61.8132 20.4942 63.2157 21.0687L70.0063 23.8499C72.2935 24.7867 73.1922 27.5528 71.8925 29.655L68.0335 35.8965C67.2365 37.1856 67.2365 38.8144 68.0335 40.1035L71.8925 46.345C73.1922 48.4472 72.2934 51.2133 70.0063 52.1501L63.2157 54.9313C61.8132 55.5058 60.8558 56.8235 60.7429 58.3349L60.1962 65.6526C60.012 68.1173 57.659 69.8268 55.2581 69.2403L48.1296 67.499C46.6573 67.1393 45.1082 67.6427 44.1285 68.799L39.3849 74.3978C37.7872 76.2836 34.8788 76.2836 33.2811 74.3978L28.5376 68.799C27.5578 67.6427 26.0087 67.1393 24.5364 67.499L17.4079 69.2403C15.007 69.8268 12.654 68.1173 12.4699 65.6526L11.9231 58.3349C11.8102 56.8235 10.8528 55.5058 9.45032 54.9313L2.6597 52.1501C0.37256 51.2133 -0.526205 48.4472 0.773523 46.345L4.63247 40.1035C5.42948 38.8144 5.42948 37.1856 4.63247 35.8965L0.77352 29.655C-0.526207 27.5528 0.372564 24.7867 2.65971 23.8499L9.45032 21.0687C10.8528 20.4942 11.8102 19.1765 11.9231 17.6651L12.4699 10.3474C12.654 7.88272 15.007 6.17317 17.4079 6.75967L24.5364 8.50102C26.0087 8.86067 27.5578 8.35733 28.5376 7.20097L33.2811 1.60217Z"
        fill={color}
      />
      <foreignObject x="5" y="20" width="65" height="35">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              color: labelStyle?.color || "#fff",
              fontSize: labelStyle?.fontSize || "12px",
              fontFamily: labelStyle?.fontFamily || "inherit",
              lineHeight: "1.2em",
              wordBreak: "break-word",
            }}
          >
            {label}
          </div>
        </div>
      </foreignObject>
    </svg>
  );
};

const spikyShape = ({
  color = "#ABDBFF",
  width = 80,
  height = 80,
  label,
  labelStyle,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 74 76"
      fill="none"
    >
      <path
        d="M35.2459 1.20193C36.0049 -0.183552 37.9951 -0.183552 38.7541 1.20193L44.253 11.24C44.7614 12.168 45.9046 12.5395 46.8613 12.0875L57.2103 7.19873C58.6387 6.52397 60.2488 7.69375 60.0484 9.26074L58.5969 20.6139C58.4628 21.6635 59.1693 22.636 60.209 22.8327L71.455 24.9606C73.0072 25.2543 73.6222 27.147 72.5391 28.297L64.6916 36.6287C63.9661 37.399 63.9661 38.601 64.6916 39.3713L72.5391 47.703C73.6222 48.853 73.0072 50.7457 71.455 51.0394L60.209 53.1673C59.1693 53.364 58.4628 54.3365 58.5969 55.3861L60.0484 66.7393C60.2488 68.3063 58.6387 69.476 57.2103 68.8013L46.8613 63.9125C45.9046 63.4606 44.7614 63.832 44.253 64.76L38.7541 74.7981C37.9951 76.1836 36.0049 76.1836 35.2459 74.7981L29.747 64.76C29.2386 63.832 28.0954 63.4606 27.1387 63.9125L16.7897 68.8013C15.3613 69.476 13.7512 68.3063 13.9516 66.7393L15.4031 55.3861C15.5372 54.3365 14.8307 53.364 13.791 53.1673L2.54499 51.0394C0.992778 50.7457 0.377793 48.853 1.46093 47.703L9.30843 39.3713C10.0339 38.601 10.0339 37.399 9.30843 36.6287L1.46093 28.297C0.377792 27.147 0.99278 25.2543 2.54499 24.9606L13.791 22.8327C14.8307 22.636 15.5372 21.6635 15.4031 20.6139L13.9516 9.26074C13.7512 7.69375 15.3613 6.52397 16.7897 7.19873L27.1387 12.0875C28.0954 12.5395 29.2386 12.168 29.747 11.24L35.2459 1.20193Z"
        fill={color}
      />
      <foreignObject x="5" y="20" width="60" height="40">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "break-word",
              color: labelStyle?.color || "#fff",
              fontSize: labelStyle?.fontSize || "12px",
              fontFamily: labelStyle?.fontFamily || "inherit",
              lineHeight: "1",
            }}
          >
            {label}
          </div>
        </div>
      </foreignObject>
    </svg>
  );
};

const rectangleShape = ({ color = "#ABDBFF", label, labelStyle }) => {
  return (
    <div
      className="common_rec_shape rectangle_shape"
      style={{
        backgroundColor: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {label && <p style={labelStyle}>{label}</p>}
    </div>
  );
};

const roundedRectangleShape = ({ color = "#ABDBFF", label, labelStyle }) => {
  return (
    <div
      className="common_rec_shape rounded_rectangle_shape"
      style={{
        backgroundColor: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {label && <p style={labelStyle}>{label}</p>}
    </div>
  );
};

const pillShape = ({ color = "#ABDBFF", label, labelStyle }) => {
  return (
    <div
      className="common_rec_shape pill_shape"
      style={{
        backgroundColor: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {label && <p style={labelStyle}>{label}</p>}
    </div>
  );
};

const shapeOptions = [
  {
    id: "circle",
    label: "Circle",
    className: "circle",
    shapeType: circleShape,
  },
  { id: "soft", label: "soft", className: "soft", shapeType: softShape },
  {
    id: "wavy",
    label: "wavy",
    className: "wavy",
    shapeType: wavyShape,
  },
  {
    id: "spiky",
    label: "spiky",
    className: "spiky",
    shapeType: spikyShape,
  },
  {
    id: "rectangle",
    label: "Rectangle",
    className: "rectangle",
    shapeType: rectangleShape,
  },
  {
    id: "roundedRectangle",
    label: "RoundedRectangle",
    className: "roundedRectangle",
    shapeType: roundedRectangleShape,
  },
  {
    id: "pill",
    label: "Pill",
    className: "pill",
    shapeType: pillShape,
  },
];

export {
  circleShape,
  softShape,
  wavyShape,
  spikyShape,
  shapeOptions,
};
